<template>
  <v-dialog :value="value" persistent max-width="800" @input="onInput">
    <v-card rounded="0">
      <v-toolbar color="kenyaGreen" dark flat>
        <v-toolbar-title class="font-weight-bold">
          {{ $t('memberDataSection.buyingStationOrder.bulkImport.successDialogTitle') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="text-center py-10 px-6">
        <div class="bso-success-circle mx-auto mb-6" :style="{ backgroundColor: themeColor('green2') }">
          <v-icon size="48" color="kenyaGreen">mdi-check</v-icon>
        </div>
        <p class="text-body-1 black--text mb-0">{{ message }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "BulkImportSuccessDialog",
  props: {
    value: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
  },
  computed: {
    message() {
      return this.$t("memberDataSection.buyingStationOrder.bulkImport.importedSuccessfully", {
        count: this.count,
      });
    },
  },
  methods: {
    themeColor(name) {
      const theme = this.$vuetify.theme;
      const variant = theme.dark ? "dark" : "light";
      return (theme.themes[variant] && theme.themes[variant][name]) || "";
    },
    onInput(val) {
      if (!val) this.close();
    },
    close() {
      this.$emit("input", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.bso-success-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
